import { OverlayEvent } from "@lib/titan2/dist/game/view/display/AbstractOverlay";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
/**
 * SlingoEvent.ts
 */
export class SlingoEvent {
    static getSlingoEvent(numberOfSlingos) {
        return SlingoEvent["SLINGO_" + numberOfSlingos];
    }
    static getPatternEvent(numberOfPatterns) {
        return SlingoEvent["MATCHED_PATTERN_" + numberOfPatterns];
    }
}
SlingoEvent.BALANCE_UPDATE = new EventObject("SlingoEvent.BALANCE_UPDATE");
SlingoEvent.WIN_UPDATED = new EventObject("SlingoEvent.WIN_UPDATED");
SlingoEvent.STAKE_INITIALISE = new EventObject("SlingoEvent.STAKE_INITIALISE");
SlingoEvent.STAKE_SELECTED_SAME = new EventObject("CommonGameEvent.STAKE_SELECTED_SAME");
SlingoEvent.STAKE_SELECTED_INCREMENT = new EventObject("CommonGameEvent.STAKE_SELECTED_INCREMENT");
SlingoEvent.STAKE_SELECTED_DECREMENT = new EventObject("CommonGameEvent.STAKE_SELECTED_DECREMENT");
SlingoEvent.MAIN_RESIZE = new EventObject("SlingoEvent.MAIN_RESIZE");
SlingoEvent.PAY_TABLE_UPDATE = new EventObject("SlingoEvent.PAY_TABLE_UPDATE");
SlingoEvent.PAY_TABLE_OPEN = new EventObject("SlingoEvent.PAY_TABLE_OPEN");
SlingoEvent.PAY_TABLE_CLOSE = new EventObject("SlingoEvent.PAY_TABLE_CLOSE");
SlingoEvent.SPIN_RESULT = new EventObject("SlingoEvent.SPIN_RESULT");
SlingoEvent.REELS_START = new EventObject("SlingoEvent.REELS_START");
SlingoEvent.REELS_AWARD = new EventObject("SlingoEvent.REELS_AWARD");
SlingoEvent.REELS_COMPLETE = new EventObject("SlingoEvent.REELS_COMPLETE");
SlingoEvent.DAB_REQUEST = new EventObject("SlingoEvent.DAB_REQUEST");
SlingoEvent.DAB_ACTIVE = new EventObject("SlingoEvent.DAB_ACTIVE");
SlingoEvent.DAB_SUCCESS = new EventObject("SlingoEvent.DAB_SUCCESS");
SlingoEvent.DAB_HIGHLIGHT = new EventObject("SlingoEvent.DAB_HIGHLIGHT");
SlingoEvent.DAB_COMPLETE = new EventObject("SlingoEvent.DAB_COMPLETE");
SlingoEvent.CHOOSE_CELL_REQUEST = new EventObject("SlingoEvent.CHOOSE_CELL_REQUEST");
SlingoEvent.CHOOSE_CELL_RESULT = new EventObject("SlingoEvent.CHOOSE_CELL_RESULT");
SlingoEvent.SLINGO_COMPLETE = new EventObject("SlingoEvent.SLINGO_COMPLETE");
SlingoEvent.SLINGO = new EventObject("SlingoEvent.SLINGO");
// Events for highlighting Slingos and updating paytable
SlingoEvent.SLINGO_TICKET_ANIMATION = new EventObject("SlingoEvent.SLINGO_TICKET_ANIMATION");
SlingoEvent.SLINGO_FOREGROUND_ANIMATION = new EventObject("SlingoEvent.SLINGO_FOREGROUND_ANIMATION");
SlingoEvent.SLINGO_TICKET_ANIMATION_COMPLETE = new EventObject("SlingoEvent.SLINGO_TICKET_ANIMATION_COMPLETE");
SlingoEvent.SLINGO_WIN_ANIMATION = new EventObject("SlingoEvent.SLINGO_WIN_ANIMATION");
SlingoEvent.SLINGO_WIN_ANIMATION_COMPLETE = new EventObject("SlingoEvent.SLINGO_WIN_ANIMATION_COMPLETE");
SlingoEvent.SLINGO_PAY_TABLE_COMPLETE = new EventObject("SlingoEvent.SLINGO_PAY_TABLE_COMPLETE");
SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_ONE = new EventObject("SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_ONE");
SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO = new EventObject("SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO");
SlingoEvent.FULL_HOUSE_ANIMATION_COMPLETE = new EventObject("SlingoEvent.FULL_HOUSE_ANIMATION_COMPLETE");
SlingoEvent.BIG_WIN_ANIMATION_PHASE_ONE = new EventObject("SlingoEvent.BIG_WIN_ANIMATION_PHASE_ONE");
SlingoEvent.BIG_WIN_ANIMATION_PHASE_TWO = new EventObject("SlingoEvent.BIG_WIN_ANIMATION_PHASE_TWO");
SlingoEvent.BIG_WIN_ANIMATION_COMPLETE = new EventObject("SlingoEvent.BIG_WIN_ANIMATION_COMPLETE");
SlingoEvent.SCATTER_WIN_ANIMATION = new EventObject("SlingoEvent.SCATTER_WIN_ANIMATION");
SlingoEvent.NO_MATCH = new EventObject("SlingoEvent.SLINGO_COMPLETE");
SlingoEvent.AVAILABLE_WIN_START = new EventObject("SlingoEvent.AVAILABLE_WIN_START");
SlingoEvent.AVAILABLE_WIN = new EventObject("SlingoEvent.AVAILABLE_WIN");
SlingoEvent.AVAILABLE_WIN_CLEAR = new EventObject("SlingoEvent.AVAILABLE_WIN_CLEAR");
SlingoEvent.AVAILABLE_WIN_END = new EventObject("SlingoEvent.AVAILABLE_WIN_END");
SlingoEvent.REEL_STRIKE = new EventObject("SlingoEvent.REEL_STRIKE");
SlingoEvent.REEL_STRIKE_NUMBER = new EventObject("SlingoEvent.REEL_STRIKE_NUMBER");
SlingoEvent.REEL_STRIKE_COIN = new EventObject("SlingoEvent.REEL_STRIKE_COIN");
SlingoEvent.REEL_STRIKE_JOKER = new EventObject("SlingoEvent.REEL_STRIKE_JOKER");
SlingoEvent.REEL_STRIKE_SUPER_JOKER = new EventObject("SlingoEvent.REEL_STRIKE_SUPER_JOKER");
SlingoEvent.REEL_STRIKE_DEVIL = new EventObject("SlingoEvent.REEL_STRIKE_DEVIL");
SlingoEvent.REEL_STRIKE_FREE_SPIN = new EventObject("SlingoEvent.REEL_STRIKE_FREE_SPIN");
SlingoEvent.REEL_STRIKE_BONUS = new EventObject("SlingoEvent.REEL_STRIKE_BONUS");
SlingoEvent.REEL_STRIKE_COLLECTABLE = new EventObject("SlingoEvent.REEL_STRIKE_COLLECTABLE");
SlingoEvent.SYMBOL_WIN_COIN = new EventObject("SlingoEvent.SYMBOL_WIN_COIN");
SlingoEvent.SYMBOL_WIN_JOKER = new EventObject("SlingoEvent.SYMBOL_WIN_JOKER");
SlingoEvent.FREE_SPIN_TWEEN = new EventObject("SlingoEvent.FREE_SPIN_TWEEN");
SlingoEvent.FREE_SPIN_AWARD = new EventObject("SlingoEvent.FREE_SPIN_AWARD");
SlingoEvent.FREE_SPIN_AWARD_NEXT = new EventObject("SlingoEvent.FREE_SPIN_AWARD_NEXT");
SlingoEvent.FREE_SPIN_AWARD_COMPLETE = new EventObject("SlingoEvent.FREE_SPIN_AWARD_COMPLETE");
SlingoEvent.DEVIL_ANIMATION = new EventObject("SlingoEvent.DEVIL_ANIMATION");
SlingoEvent.DEVIL_ANIMATION_COMPLETE = new EventObject("SlingoEvent.DEVIL_ANIMATION_COMPLETE");
SlingoEvent.CHERUB_ANIMATION = new EventObject("SlingoEvent.CHERUB_ANIMATION");
SlingoEvent.CHERUB_ANIMATION_COMPLETE = new EventObject("SlingoEvent.CHERUB_ANIMATION_COMPLETE");
SlingoEvent.WIN_DISPLAY_START = new EventObject("SlingoEvent.WIN_DISPLAY_START");
SlingoEvent.WIN_DISPLAY_COMPLETE = new EventObject("SlingoEvent.WIN_DISPLAY_COMPLETE");
SlingoEvent.SLINGO_PAY_TABLE = new EventObject("SlingoEvent.SLINGO_PAY_TABLE");
SlingoEvent.GAME_SUMMARY = new EventObject("SlingoEvent.GAME_SUMMARY");
SlingoEvent.GAME_SUMMARY_COMPLETE = new EventObject("SlingoEvent.GAME_SUMMARY_COMPLETE");
SlingoEvent.REEL_SYMBOL_HIGHLIGHT = new EventObject("SlingoEvent.REEL_SYMBOL_HIGHLIGHT");
// Express game can award 5+ slingos at once
SlingoEvent.SLINGO_1 = new EventObject("SlingoEvent.SLINGO_1");
SlingoEvent.SLINGO_2 = new EventObject("SlingoEvent.SLINGO_2");
SlingoEvent.SLINGO_3 = new EventObject("SlingoEvent.SLINGO_3");
SlingoEvent.SLINGO_4 = new EventObject("SlingoEvent.SLINGO_4");
SlingoEvent.SLINGO_5 = new EventObject("SlingoEvent.SLINGO_5");
SlingoEvent.SLINGO_6 = new EventObject("SlingoEvent.SLINGO_6");
SlingoEvent.SLINGO_7 = new EventObject("SlingoEvent.SLINGO_7");
SlingoEvent.SLINGO_8 = new EventObject("SlingoEvent.SLINGO_8");
SlingoEvent.SLINGO_9 = new EventObject("SlingoEvent.SLINGO_9");
SlingoEvent.SLINGO_10 = new EventObject("SlingoEvent.SLINGO_10");
SlingoEvent.SLINGO_11 = new EventObject("SlingoEvent.SLINGO_11");
SlingoEvent.SLINGO_12 = new EventObject("SlingoEvent.SLINGO_12");
SlingoEvent.MATCHED_PATTERN_1 = new EventObject("SlingoEvent.MATCHED_PATTERN_1");
SlingoEvent.MATCHED_PATTERN_2 = new EventObject("SlingoEvent.MATCHED_PATTERN_2");
SlingoEvent.MATCHED_PATTERN_3 = new EventObject("SlingoEvent.MATCHED_PATTERN_3");
SlingoEvent.MATCHED_PATTERN_4 = new EventObject("SlingoEvent.MATCHED_PATTERN_4");
SlingoEvent.MATCHED_PATTERN_5 = new EventObject("SlingoEvent.MATCHED_PATTERN_5");
SlingoEvent.MATCHED_PATTERN_6 = new EventObject("SlingoEvent.MATCHED_PATTERN_6");
SlingoEvent.MATCHED_PATTERN_7 = new EventObject("SlingoEvent.MATCHED_PATTERN_7");
SlingoEvent.MATCHED_PATTERN_8 = new EventObject("SlingoEvent.MATCHED_PATTERN_8");
SlingoEvent.MATCHED_PATTERN_9 = new EventObject("SlingoEvent.MATCHED_PATTERN_9");
SlingoEvent.MATCHED_PATTERN_10 = new EventObject("SlingoEvent.MATCHED_PATTERN_10");
SlingoEvent.MATCHED_PATTERN_11 = new EventObject("SlingoEvent.MATCHED_PATTERN_11");
SlingoEvent.MATCHED_PATTERN_12 = new EventObject("SlingoEvent.MATCHED_PATTERN_12");
SlingoEvent.SCATTER_WIN_APPEAR = new EventObject("SlingoEvent.SCATTER_WIN_APPEAR");
SlingoEvent.SCATTER_WIN_COUNT = new EventObject("SlingoEvent.SCATTER_WIN_COUNT");
SlingoEvent.SCATTER_WIN_COUNT_END = new EventObject("SlingoEvent.SCATTER_WIN_COUNT_END");
SlingoEvent.SCATTER_WIN_DISAPPEAR = new EventObject("SlingoEvent.SCATTER_WIN_DISAPPEAR");
SlingoEvent.BIG_WIN_APPEAR = new EventObject("SlingoEvent.BIG_WIN_APPEAR");
SlingoEvent.BIG_WIN_COUNT = new EventObject("SlingoEvent.BIG_WIN_COUNT");
SlingoEvent.BIG_WIN_COUNT_END = new EventObject("SlingoEvent.BIG_WIN_COUNT_END");
SlingoEvent.BIG_WIN_DISAPPEAR = new EventObject("SlingoEvent.BIG_WIN_DISAPPEAR");
SlingoEvent.FULL_HOUSE_APPEAR = new EventObject("SlingoEvent.FULL_HOUSE_WIN_APPEAR");
SlingoEvent.FULL_HOUSE_COUNT = new EventObject("SlingoEvent.FULL_HOUSE_WIN_COUNT");
SlingoEvent.FULL_HOUSE_COUNT_END = new EventObject("SlingoEvent.FULL_HOUSE_WIN_COUNT_END");
SlingoEvent.FULL_HOUSE_DISAPPEAR = new EventObject("SlingoEvent.FULL_HOUSE_WIN_DISAPPEAR");
SlingoEvent.SUSPENSE_SPIN = new EventObject("SlingoEvent.SUSPENSE_SPIN");
SlingoEvent.UPDATE_WILD_COUNTER = new EventObject("SlingoEvent.UPDATE_WILD_COUNTER");
SlingoEvent.HIDE_HIGHLITED_JOKER = new EventObject("SlingoEvent.HIDE_HIGHLITED_JOKER");
SlingoEvent.HIDE_ALL_SYMBOLS = new EventObject("SlingoEvent.HIDE_ALL_SYMBOLS");
SlingoEvent.DAB_ALL_SYMBOLS = new EventObject("SlingoEvent.DAB_ALL_SYMBOLS");
SlingoEvent.SLINGO_ANIMATION = new EventObject("SlingoEvent.SLINGO_ANIMATION");
/**
 * ReelEvent.ts
 */
export class ReelEvent {
}
ReelEvent.SPIN_REEL = new EventObject("ReelEvent.SPIN_REEL");
ReelEvent.STOP_REEL = new EventObject("ReelEvent.STOP_REEL");
ReelEvent.REEL_STOPPED = new EventObject("ReelEvent.REEL_STOPPED");
ReelEvent.DISABLE_REELS = new EventObject("ReelEvent.DISABLE_REELS");
ReelEvent.RECOVER = new EventObject("ReelEvent.RECOVER");
ReelEvent.RESET = new EventObject("ReelEvent.RESET");
ReelEvent.SHOW = new EventObject("ReelEvent.SHOW");
/**
 * FreeSpinOverlayEvent.ts
 */
export class FreeSpinOverlayEvent extends OverlayEvent {
}
FreeSpinOverlayEvent.FREE_SPIN_START = new EventObject("OverlayEvent.FREE_SPIN_START");
FreeSpinOverlayEvent.FREE_SPIN_END = new EventObject("OverlayEvent.FREE_SPIN_END");
/**
 * TestEvent.ts
 */
export class TestEvent {
}
TestEvent.GAME_SUMMARY = new EventObject("TestEvent.GAME_SUMMARY");
TestEvent.GAME_OVER = new EventObject("TestEvent.GAME_OVER");
TestEvent.SLINGO_1 = new EventObject("TestEvent.SLINGO_1");
TestEvent.SLINGO_2 = new EventObject("TestEvent.SLINGO_2");
TestEvent.SLINGO_3 = new EventObject("TestEvent.SLINGO_3");
TestEvent.SLINGO_4 = new EventObject("TestEvent.SLINGO_4");
//# sourceMappingURL=SlingoEvent.js.map